/**
 * AiBuddyDisclaimerModal — the AI support disclaimer shown from AI Settings.
 */
import { useTranslation } from '@wlb/shared/i18n/useTranslation';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import { AlertCircleIcon, InfoIcon, RobiIcon } from '../../components/ui/icons';
import './settings.css';

interface AiBuddyDisclaimerModalProps {
  onClose: () => void;
  /** Called when the user clicks Continue. Falls back to onClose. */
  onContinue?: () => void;
}

const POINTS = [
  ['aiGenerated', RobiIcon],
  ['useJudgment', InfoIcon],
  ['notMedical', AlertCircleIcon],
] as const;

export function AiBuddyDisclaimerModal({ onClose, onContinue }: AiBuddyDisclaimerModalProps) {
  const { t } = useTranslation();
  const handleContinue = onContinue ?? onClose;

  return (
    <Modal
      title={t('aiBuddy.disclaimer.title')}
      labelledBy="ai-disclaimer-title"
      onClose={onClose}
    >
      <div className="ai-disclaimer">
        <p className="ai-disclaimer__intro">{t('aiBuddy.disclaimer.description')}</p>
        <ul className="ai-disclaimer__list">
          {POINTS.map(([key, Icon]) => (
            <li key={key} className="ai-disclaimer__item">
              <span className="settings-row__icon">
                <Icon size={18} />
              </span>
              <span className="settings-row__copy">
                <span className="ai-disclaimer__title">
                  {t(`aiBuddy.disclaimer.${key}Title`)}
                </span>
                <span className="ai-disclaimer__description">
                  {t(`aiBuddy.disclaimer.${key}Desc`)}
                </span>
              </span>
            </li>
          ))}
        </ul>
        <div className="settings-confirm__actions">
          {onContinue && (
            <Button variant="ghost" onClick={onClose}>
              {t('aiBuddy.disclaimer.close')}
            </Button>
          )}
          <Button onClick={handleContinue}>{t('aiBuddy.disclaimer.continue')}</Button>
        </div>
      </div>
    </Modal>
  );
}
